import _lib from '../_lib';
import active from './active/index';
import {NotesNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'notes';
  let activations = [
    {
      name: 'notes',
      test: api.messageIs(NotesNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};